import { InitialIntegrationReducer } from "../../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../../_commons/integration.reducer";

export const initialZalandoPaymentsReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
    reports: [],
    uploadSummary: null,
};

const zalandoPaymentsSlice = createSlice({
    name: "Zalando Payments",
    initialState: { ...initialZalandoPaymentsReducer },
    reducers: {
        ...integrationReducerActions,
        setReports(state, action) {
            state.reports = action.payload;
        },
        setUploadSummary(state, action) {
            state.uploadSummary = action.payload;
        },
    },
});

export default zalandoPaymentsSlice;
